module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<table>\n  <tr>\n    <td class="fmcy-other-location-td-name-column location-table-available-at-title-column">\n      <div class="location-table-available-at-title"></div>\n    </td>\n    <td class="selected-location-prices-region-column">\n      <div class="selected-location-prices-region"></div>\n    </td>\n  </tr>\n</table>\n<div class="location-table-available-at-table-wrapper">\n  <div class="other-location-prices-region"></div>\n</div>\n';
}
return __p;
};



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/menu/common/menu-item-prices-location-table/menu-item-prices-location-table.html
 ** module id = 862
 ** module chunks = 1 16 87
 **/